import { useNavigate } from "react-router-dom";
import Button from "../../../common/components/button/Button";
import { routeConfig } from "../../../common/constants/routeConfig";
import styles from "./PosAcc.module.scss";
import PosAccListing from "./PosAccListing/PosAccListing";

function PosAcc() {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.rightContainer}>
        <div className={styles.supplierContainer}>
          <div className={styles.heading}>
            <div className={styles.commonHeading}>POS Accounts List</div>
            <div className={styles.addForms}>
              {/* for 21 october */}
              <Button
                handleClick={() => {
                  navigate(routeConfig.posTypes);
                }}
                label="Connect POS Account"
                width="200px"
                secondary={true}
              />
            </div>
          </div>
          <PosAccListing />
        </div>
      </div>
    </div>
  );
}

export default PosAcc;
